import { render, staticRenderFns } from "./ModalProgramCriteria.vue?vue&type=template&id=471aea57&scoped=true&"
import script from "./ModalProgramCriteria.vue?vue&type=script&lang=js&"
export * from "./ModalProgramCriteria.vue?vue&type=script&lang=js&"
import style0 from "./ModalProgramCriteria.vue?vue&type=style&index=0&id=471aea57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471aea57",
  null
  
)

export default component.exports